export class RegistrationPassword {

  password: string;
  newPassword: string;
  newPasswordCheck: string;

  constructor() {
    this.password = null;
    this.newPassword = null;
    this.newPasswordCheck = null;
  }

}



// WEBPACK FOOTER //
// ./src/models/registrationpassword.ts